import React, { FC, ReactNode } from "react";
import { Toast } from "react-bootstrap";
import { ExclamationCircle, XLg } from "react-bootstrap-icons";

type Props = {
  show: boolean;
  onCancel?: () => void;
  icon?: ReactNode;
  message: string | ReactNode;
  backgroundStyles?: string;
  textStyles?: string;
  button?: ReactNode;
  isSeenClose?: boolean;
};

export const PremiumPlanToast: FC<Props> = ({
  show,
  onCancel,
  icon = <ExclamationCircle />,
  message,
  backgroundStyles = "",
  textStyles = "",
  button = <></>,
  isSeenClose = false,
}) => {
  return (
    <div
      className={`col-12 ${show ? "d-flex" : "d-none"} justify-content-center`}
    >
      <Toast
        show={show}
        onClose={onCancel}
        className={`w-100 ${backgroundStyles} ${!backgroundStyles.includes("p") && "p-3"}`}
        style={{ boxShadow: "none" }}
      >
        <Toast.Body className="d-flex justify-content-between p-0 position-relative">
          <div className="d-flex flex-wrap align-items-center gap-2 w-fit-content">
            <div className="d-flex">
              {icon}
              {typeof message === "string" ? (
                <p className={`m-0 ${textStyles}`} style={{ fontSize: "18px" }}>
                  {message}
                </p>
              ) : (
                message
              )}
            </div>
            {button}
          </div>
          {isSeenClose && (
            <XLg
              className="align-self-md-center cursor-pointer"
              onClick={onCancel}
            />
          )}
        </Toast.Body>
      </Toast>
    </div>
  );
};
